// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-carousel-container {
  position: relative;
  height: 420px;
  overflow: hidden;
  background: #000;
  margin-bottom: 0px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  margin-top: -60px;
}
.page-carousel-container .page-carousel-inner {
  position: relative;
  height: 100%;
  display: flex;
  align-items: stretch;
}
.page-carousel-container .page-carousel-item {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  opacity: 0;
  transition: opacity 0.6s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-carousel-container .page-carousel-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.45) 100%);
  z-index: 0;
}
.page-carousel-container .page-carousel-item.active {
  opacity: 1;
}
.page-carousel-container .page-carousel-item .page-carousel-caption {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(0, 0, 0, 0.5);
  max-width: 950px;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}
.page-carousel-container .page-carousel-item .page-carousel-description {
  font-size: 14px;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
  color: #e8e8e8;
  font-weight: 500;
  line-height: 1.3;
}
@media (max-width: 1024px) {
  .page-carousel-container .page-carousel-item .page-carousel-description {
    font-size: 13px;
  }
}
@media (max-width: 768px) {
  .page-carousel-container .page-carousel-item .page-carousel-description {
    font-size: 11px;
    margin-bottom: 4px;
  }
}
@media (max-width: 576px) {
  .page-carousel-container .page-carousel-item .page-carousel-description {
    font-size: 9px;
  }
}
.page-carousel-container .page-carousel-item .page-carousel-description sup {
  font-size: 0.7em;
}
.page-carousel-container .page-carousel-item .page-carousel-title {
  font-size: 52px;
  font-weight: 900;
  margin-bottom: 4px;
  color: white;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
@media (max-width: 1024px) {
  .page-carousel-container .page-carousel-item .page-carousel-title {
    font-size: 46px;
  }
}
@media (max-width: 768px) {
  .page-carousel-container .page-carousel-item .page-carousel-title {
    font-size: 34px;
    margin-bottom: 3px;
  }
}
@media (max-width: 576px) {
  .page-carousel-container .page-carousel-item .page-carousel-title {
    font-size: 24px;
    letter-spacing: 0.2px;
  }
}
.page-carousel-container .page-carousel-item .page-carousel-dates {
  font-size: 16px;
  margin-bottom: 2px;
  color: white;
  margin: 0.05rem 0;
  font-weight: 700;
  letter-spacing: 0.2px;
}
@media (max-width: 1024px) {
  .page-carousel-container .page-carousel-item .page-carousel-dates {
    font-size: 15px;
  }
}
@media (max-width: 768px) {
  .page-carousel-container .page-carousel-item .page-carousel-dates {
    font-size: 12px;
  }
}
@media (max-width: 576px) {
  .page-carousel-container .page-carousel-item .page-carousel-dates {
    font-size: 10px;
  }
}
.page-carousel-container .page-carousel-item .page-carousel-dates sup {
  font-size: 0.75em;
}
.page-carousel-container .page-carousel-item .page-carousel-location {
  font-size: 14px;
  margin-bottom: 0;
  color: #f0f0f0;
  margin: 0.08rem 0;
  font-weight: 600;
  letter-spacing: 0.15px;
  line-height: 1.25;
}
@media (max-width: 1024px) {
  .page-carousel-container .page-carousel-item .page-carousel-location {
    font-size: 13px;
  }
}
@media (max-width: 768px) {
  .page-carousel-container .page-carousel-item .page-carousel-location {
    font-size: 11px;
  }
}
@media (max-width: 576px) {
  .page-carousel-container .page-carousel-item .page-carousel-location {
    font-size: 9px;
  }
}
.page-carousel-container .page-carousel-item .page-carousel-divider {
  width: 60%;
  max-width: 480px;
  height: 1.5px;
  margin: 8px auto 6px auto;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.3), transparent);
  border-radius: 2px;
}
.page-carousel-container .page-carousel-item .page-carousel-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.page-carousel-container .page-carousel-item .page-carousel-logos .page-carousel-logo {
  width: 70px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4));
  transition: transform 0.3s ease, filter 0.3s ease;
}
.page-carousel-container .page-carousel-item .page-carousel-logos .page-carousel-logo:hover {
  transform: scale(1.05);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.6));
}
@media (max-width: 1024px) {
  .page-carousel-container .page-carousel-item .page-carousel-logos .page-carousel-logo {
    width: 65px;
    gap: 30px;
  }
}
@media (max-width: 768px) {
  .page-carousel-container .page-carousel-item .page-carousel-logos .page-carousel-logo {
    width: 55px;
    gap: 20px;
  }
}
@media (max-width: 576px) {
  .page-carousel-container .page-carousel-item .page-carousel-logos .page-carousel-logo {
    width: 45px;
    gap: 12px;
  }
}
.page-carousel-container .page-carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 32px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: 10;
  line-height: 1;
}
.page-carousel-container .page-carousel-control:hover {
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-color: white;
  transform: translateY(-50%) scale(1.12);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
}
.page-carousel-container .page-carousel-control:active {
  transform: translateY(-50%) scale(0.98);
}
.page-carousel-container .page-carousel-control.prev {
  left: 20px;
}
.page-carousel-container .page-carousel-control.next {
  right: 20px;
}
@media (max-width: 1024px) {
  .page-carousel-container .page-carousel-control {
    font-size: 28px;
    padding: 10px 14px;
  }
}
@media (max-width: 768px) {
  .page-carousel-container .page-carousel-control {
    font-size: 24px;
    padding: 8px 12px;
    border-width: 1.5px;
  }
  .page-carousel-container .page-carousel-control.prev {
    left: 12px;
  }
  .page-carousel-container .page-carousel-control.next {
    right: 12px;
  }
  .page-carousel-container .page-carousel-control:hover {
    transform: translateY(-50%) scale(1.08);
  }
}
@media (max-width: 576px) {
  .page-carousel-container .page-carousel-control {
    font-size: 18px;
    padding: 6px 10px;
  }
  .page-carousel-container .page-carousel-control.prev {
    left: 8px;
  }
  .page-carousel-container .page-carousel-control.next {
    right: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/page-carousel.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,iBAAA;AADF;AAGE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,UAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;AAII;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qFAAA;EACA,UAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,wEAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAJN;AAOI;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AALN;AAOM;EARF;IASI,eAAA;EAJN;AACF;AAMM;EAZF;IAaI,eAAA;IACA,kBAAA;EAHN;AACF;AAKM;EAjBF;IAkBI,cAAA;EAFN;AACF;AAIM;EACE,gBAAA;AAFR;AAMI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;AAJN;AAMM;EARF;IASI,eAAA;EAHN;AACF;AAKM;EAZF;IAaI,eAAA;IACA,kBAAA;EAFN;AACF;AAIM;EAjBF;IAkBI,eAAA;IACA,qBAAA;EADN;AACF;AAII;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAFN;AAIM;EARF;IASI,eAAA;EADN;AACF;AAGM;EAZF;IAaI,eAAA;EAAN;AACF;AAEM;EAhBF;IAiBI,eAAA;EACN;AACF;AACM;EACE,iBAAA;AACR;AAGI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AADN;AAGM;EATF;IAUI,eAAA;EAAN;AACF;AAEM;EAbF;IAcI,eAAA;EACN;AACF;AACM;EAjBF;IAkBI,cAAA;EAEN;AACF;AACI;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,yFAAA;EACA,kBAAA;AACN;AAEI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAAN;AAEM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,iDAAA;AAAR;AAEQ;EACE,sBAAA;EACA,iDAAA;AAAV;AAGQ;EAZF;IAaI,WAAA;IACA,SAAA;EAAR;AACF;AAEQ;EAjBF;IAkBI,WAAA;IACA,SAAA;EACR;AACF;AACQ;EAtBF;IAuBI,WAAA;IACA,SAAA;EAER;AACF;AAGE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,8BAAA;EACA,0CAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yDAAA;EACA,WAAA;EACA,cAAA;AADJ;AAGI;EACE,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,6CAAA;AADN;AAII;EACE,uCAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACE,WAAA;AAJN;AAOI;EAnCF;IAoCI,eAAA;IACA,kBAAA;EAJJ;AACF;AAMI;EAxCF;IAyCI,eAAA;IACA,iBAAA;IACA,mBAAA;EAHJ;EAKI;IACE,UAAA;EAHN;EAMI;IACE,WAAA;EAJN;EAOI;IACE,uCAAA;EALN;AACF;AAQI;EA1DF;IA2DI,eAAA;IACA,iBAAA;EALJ;EAOI;IACE,SAAA;EALN;EAQI;IACE,UAAA;EANN;AACF","sourcesContent":["$primary-color: #70b60a;\n\n.page-carousel-container {\n  position: relative;\n  height: 420px;\n  overflow: hidden;\n  background: #000;\n  margin-bottom: 0px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n  margin-top:-60px;\n\n  .page-carousel-inner {\n    position: relative;\n    height: 100%;\n    display: flex;\n    align-items: stretch;\n  }\n\n  .page-carousel-item {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    background-attachment: fixed;\n    opacity: 0;\n    transition: opacity 0.6s ease-in-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: linear-gradient(135deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.45) 100%);\n      z-index: 0;\n    }\n\n    &.active {\n      opacity: 1;\n    }\n\n    .page-carousel-caption {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      color: white;\n      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(0, 0, 0, 0.5);\n      max-width: 950px;\n      padding: 0 20px;\n      position: relative;\n      z-index: 1;\n    }\n\n    .page-carousel-description {\n      font-size: 14px;\n      letter-spacing: 0.3px;\n      margin-bottom: 6px;\n      color: #e8e8e8;\n      font-weight: 500;\n      line-height: 1.3;\n\n      @media (max-width: 1024px) {\n        font-size: 13px;\n      }\n\n      @media (max-width: 768px) {\n        font-size: 11px;\n        margin-bottom: 4px;\n      }\n\n      @media (max-width: 576px) {\n        font-size: 9px;\n      }\n\n      sup {\n        font-size: 0.7em;\n      }\n    }\n\n    .page-carousel-title {\n      font-size: 52px;\n      font-weight: 900;\n      margin-bottom: 4px;\n      color: white;\n      letter-spacing: 0.5px;\n      text-transform: uppercase;\n\n      @media (max-width: 1024px) {\n        font-size: 46px;\n      }\n\n      @media (max-width: 768px) {\n        font-size: 34px;\n        margin-bottom: 3px;\n      }\n\n      @media (max-width: 576px) {\n        font-size: 24px;\n        letter-spacing: 0.2px;\n      }\n    }\n\n    .page-carousel-dates {\n      font-size: 16px;\n      margin-bottom: 2px;\n      color: white;\n      margin: 0.05rem 0;\n      font-weight: 700;\n      letter-spacing: 0.2px;\n\n      @media (max-width: 1024px) {\n        font-size: 15px;\n      }\n\n      @media (max-width: 768px) {\n        font-size: 12px;\n      }\n\n      @media (max-width: 576px) {\n        font-size: 10px;\n      }\n\n      sup {\n        font-size: 0.75em;\n      }\n    }\n\n    .page-carousel-location {\n      font-size: 14px;\n      margin-bottom: 0;\n      color: #f0f0f0;\n      margin: 0.08rem 0;\n      font-weight: 600;\n      letter-spacing: 0.15px;\n      line-height: 1.25;\n\n      @media (max-width: 1024px) {\n        font-size: 13px;\n      }\n\n      @media (max-width: 768px) {\n        font-size: 11px;\n      }\n\n      @media (max-width: 576px) {\n        font-size: 9px;\n      }\n    }\n\n    .page-carousel-divider {\n      width: 60%;\n      max-width: 480px;\n      height: 1.5px;\n      margin: 8px auto 6px auto;\n      background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.3), transparent);\n      border-radius: 2px;\n    }\n\n    .page-carousel-logos {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 40px;\n      flex-wrap: wrap;\n      margin-top: 4px;\n\n      .page-carousel-logo {\n        width: 70px;\n        height: auto;\n        object-fit: contain;\n        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4));\n        transition: transform 0.3s ease, filter 0.3s ease;\n\n        &:hover {\n          transform: scale(1.05);\n          filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.6));\n        }\n\n        @media (max-width: 1024px) {\n          width: 65px;\n          gap: 30px;\n        }\n\n        @media (max-width: 768px) {\n          width: 55px;\n          gap: 20px;\n        }\n\n        @media (max-width: 576px) {\n          width: 45px;\n          gap: 12px;\n        }\n      }\n    }\n  }\n\n  .page-carousel-control {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: rgba(0, 0, 0, 0.3);\n    border: 2px solid rgba(255, 255, 255, 0.6);\n    border-radius: 4px;\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 32px;\n    padding: 12px 16px;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n    z-index: 10;\n    line-height: 1;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.6);\n      color: #fff;\n      border-color: white;\n      transform: translateY(-50%) scale(1.12);\n      box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);\n    }\n\n    &:active {\n      transform: translateY(-50%) scale(0.98);\n    }\n\n    &.prev {\n      left: 20px;\n    }\n\n    &.next {\n      right: 20px;\n    }\n\n    @media (max-width: 1024px) {\n      font-size: 28px;\n      padding: 10px 14px;\n    }\n\n    @media (max-width: 768px) {\n      font-size: 24px;\n      padding: 8px 12px;\n      border-width: 1.5px;\n\n      &.prev {\n        left: 12px;\n      }\n\n      &.next {\n        right: 12px;\n      }\n\n      &:hover {\n        transform: translateY(-50%) scale(1.08);\n      }\n    }\n\n    @media (max-width: 576px) {\n      font-size: 18px;\n      padding: 6px 10px;\n\n      &.prev {\n        left: 8px;\n      }\n\n      &.next {\n        right: 8px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
